<template>
  <validation-observer ref="observer">
    <div class="ma-4">
      <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar>
      <v-card>
        <v-tabs v-model="tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab v-for="item in items" :key="item">
            {{ item }}
        </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="(item, i) in items" :key="item">
      <v-data-table 
        :headers="headers" 
        :items="i === 0 ? codes : inactive" 
        sort-by="Code" 
        sort-asc 
        class="elevation-1" 
        :loading="isLoading"
        loading-text="Loading Service Codes" 
        :search="search">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Service Codes</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" clearable flat solo-inverted hide-details prepend-inner-icon="search"
              label="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="75%">
              <template v-slot:activator="{ on }">
                <v-btn color="#2b3990" dark class="mb-2" v-on="on" @click="showAdd()">
                  <v-icon left>add</v-icon>
                  Add Service Code</v-btn>
              </template>
              <v-card>
                <v-card-title style="background-color: #2b3990">
                  <span class="headline white--text">{{ titleForm }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6" sm="6" md="6">
                        <validation-provider v-slot="{ errors }" name="Service Code" rules="required">
                          <v-text-field v-model="newCode" label="Service Code" :error-messages="errors"></v-text-field>
                        </validation-provider>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <validation-provider v-slot="{ errors }" name="Service Code Title" rules="required">
                          <v-text-field v-model="newTitle" label="Service Code Title"
                            :error-messages="errors"></v-text-field>
                        </validation-provider>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <validation-provider v-slot="{ errors }" name="Unit of Service" rules="required">
                          <v-autocomplete v-model="newUnit" label="Unit of Service" outlined :error-messages="errors"
                            :items="units"></v-autocomplete>
                        </validation-provider>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <validation-provider v-slot="{ errors }" name="State" rules="required">
                          <v-autocomplete v-model="state" label="State" outlined :error-messages="errors"
                            :items="states"></v-autocomplete>
                        </validation-provider>
                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <validation-provider v-slot="{ errors }" name="Status" rules="required">
                          <v-switch
                          :label="isActive ? 'Active' : 'Inactive'"
                           v-model="isActive" 
                           :error-messages="errors"
                          ></v-switch>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#259647" class="white--text" @click="addCode()" v-if="newServCode">Save</v-btn>
                  <v-btn color="blue darken-1" text @click="updateCode()" v-if="editCode">Update</v-btn>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>

        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="viewCode(item)">
            mdi-eye
          </v-icon>
          <!-- <v-icon small class="mr-2" @click="editCode(item)">
          mdi-pencil
        </v-icon> -->
          <v-icon small @click="deleteCode(item)">
            mdi-delete
          </v-icon>
          <!-- <v-icon small @click="addDeal(item)">
          add
        </v-icon> -->
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getCodes()">Reset</v-btn>
        </template>
      </v-data-table>
    </v-tab-item>
    </v-tabs-items>
    </v-card>
      <Foot />
    </div>
  </validation-observer>
</template>

<script>
import axios from 'axios'
import Foot from '../components/Footer'
import { ValidationObserver, ValidationProvider } from "vee-validate";

const url = require("../client_config/config").url;

export default {
  components: {
    Foot, ValidationProvider, ValidationObserver
  },
  data: function () {
    return {
      headers: [
        {
          text: 'Service Code',
          align: 'start',
          sortable: false,
          value: 'Code',
        },
        { text: "Service Code Title", value: "Title" },
        { text: "Unit of Service", value: "Unit" },
        { text: "State", value: "State" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tab: null,
      items: ["Active Codes", "Inactive Codes"],
      dialog: false,
      editCode: false,
      newServCode: false,
      msg: false,
      search: "",
      text: "",
      codes: [],
      inactive: [],
      units: ["Daily", "Hourly", "Quarter Hour", "Monthly", "Session"],
      titleForm: "New Service Code",
      codeID: "",
      newCode: "",
      newTitle: "",
      newUnit: "",
      userState: localStorage.getItem('userState'),
      editedIndex: -1,
      editedItem: {
        code: "",
        title: "",
        units: "",
      },
      defaultItem: {
        code: "",
        title: "",
        units: "",
      },
      isLoading: true,
      states: ["Utah", "Nevada"],
      state: "",
      isActive: true
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.getCodes();
  },

  methods: {
    initialize() {
      this.codes = [];
    },
    viewCode(item) {
      this.titleForm = "Viewing " + item.Title;
      this.dialog = true;
      this.editCode = true;
      this.newServCode = false;
      this.newCode = item.Code;
      this.newTitle = item.Title;
      this.newUnit = item.Unit;
      this.codeID = item._id;
      this.state = item.State
      this.isActive = item?.Status === undefined || item?.Status === 'Active' ? true : false;
    },
    showAdd() {
      this.titleForm = "New Service Code";
      this.newServCode = true;
      this.editCode = false;
    },

    deleteCode(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this service code?") &&
        this.codeDelete(id);

    },

    codeDelete(id) {
      axios.delete(`${url}/codes/${id}`)
        .then((response) => {
          this.getCodes();
          if (response.status == 400) {
            response.json().then(function (data) {
              return data.msg;
            });
          }
          this.msg = true;
          this.text = "The code has been deleted successfully.";
        });
    },

    close() {
      this.dialog = false;
      this.isActive = true
      this.clear();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateCode() {
      var req_body = {
        Code: this.newCode,
        Title: this.newTitle,
        Unit: this.newUnit,
        Status: this.isActive ? 'Active' : 'Inactive',
        State: this.state
      };

      axios.put(`${url}/codes/${this.codeID}`, req_body).then((response) => {
        this.getCodes();
        if (response.status == 400) {
          response.json().then(function (data) {
            alert(data.msg);
          });
        }
        this.clear()
        this.msg = true;
        this.text = "The service code has been updated successfully.";
      });
      this.close();
    },
    getCodes: function () {
      this.isLoading = true;
      axios.get(`${url}/codes/status/codes/${this.userState}`).then(res => {
        this.codes = res.data.activeCodes;
        this.inactive = res.data.inactiveCodes;
      }).finally(() => this.isLoading = false);
    },

    async addCode() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        var req_body = {
          Code: this.newCode,
          Title: this.newTitle,
          Unit: this.newUnit,
          Status: this.isActive ? 'Active' : 'Inactive',
          State: this.state
        };

        axios.post(`${url}/codes`, req_body).then(res => {
          this.getCodes();
          if (res.status == 400) {
            res.json().then(function (data) {
              this.text = data.msg;
            });
          }
          this.clear()
          this.msg = true;
          this.text = "The new sevice code has been added successfully.";
        });
        this.close();
      }

    },

    clear() {
      this.newCode = "";
      this.newTitle = "";
      this.newUnit = "";
      this.state = "";
      this.$refs.observer.reset()
    }
  },

};
</script>
